/**
 * Code generated by scripts/gen-phosphor-icons.mjs. DO NOT EDIT.
 * Phosphor Icons 2.1.1, MIT License. See NOTICE.md.
 */

import {createSinglePathSVG} from './TEMPLATE'

// Phosphor: funnel-simple (regular)
export const FilterTimeline_Stroke2_Corner0_Rounded = createSinglePathSVG({
  viewBox: '0 0 256 256',
  path: 'M200,136a8,8,0,0,1-8,8H64a8,8,0,0,1,0-16H192A8,8,0,0,1,200,136Zm32-56H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Zm-80,96H104a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z',
})
